
import xor from 'lodash/xor';
import Vue, { PropType } from 'vue';
import { SelectOption } from '~/components/builders/Base/Select.vue';
import AttributeIcon, { AttributeIconType } from './AttributeIcon.vue';

export default Vue.extend({
    name: 'AttributeCheckbox',
    components: { AttributeIcon },
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        optionValues: {
            type: Array as PropType<string[]>,
            default: () => [],
        },
        options: {
            type: Array as PropType<SelectOption[]>,
            default: () => [],
        },

        type: {
            type: String as PropType<AttributeIconType>,
            required: true,
        },
    },
    methods: {
        isChecked(value: string): boolean {
            return this.optionValues.includes(value);
        },
        handleOptionChange(value: string) {
            const newOptions = xor(this.optionValues, [value]);
            this.$emit('optionChange', newOptions);
        },
    },
});
